const React = require('react');
const ArrowA = require('../../icons/ArrowA');


module.exports = (props) => {
  return (
    <div className="layoutRow fhaC fvaC sq30 abs eN sr17 st50%-14">
      <ArrowA className="w14"/>
    </div>
  );
};
